<template>
  <div class="hospitalsDetailGraph" :class="{ '-lg': lg }">
    <template v-for="(item, i) in data" :key="i">
      <div
        v-if="item.rate"
        class="hospitalsDetailGraph_item"
        :class="{ '-lg': lg }"
      >
        <div class="hospitalsDetailGraph_label">{{ item.label }}</div>
        <div class="hospitalsDetailGraph_rate">
          <span class="is-active"></span>
          <span :class="{ 'is-active': Number(item.rate) >= 2 }"></span>
          <span :class="{ 'is-active': Number(item.rate) >= 3 }"></span>
          <span :class="{ 'is-active': Number(item.rate) >= 4 }"></span>
          <span :class="{ 'is-active': Number(item.rate) >= 5 }"></span>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
export default {
  name: 'HospitalsDetailGraph',
  props: {
    data: Array,
    lg: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalsDetailGraph {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;

  &.-lg {
    @include mixins.media() {
      justify-content: flex-start;
    }
  }

  &_item {
    flex-basis: 70%;
    width: 70%;
    max-width: 70%;
    display: flex;
    align-items: center;
    padding-top: 6px;
    padding-bottom: 6px;

    @media screen and (min-width: 375px) {
      flex-basis: 47.5%;
      width: 47.5%;
      max-width: 180px;
    }

    &.-lg {
      width: 100%;
      max-width: 500px;
      justify-content: space-between;

      @include mixins.media() {
        width: calc(50% - 30px);
        max-width: 340px;
        margin-right: 30px;

        &:nth-child(2) {
          order: 3;
        }
        &:nth-child(3) {
          order: 2;
        }
        &:nth-child(4) {
          order: 4;
        }
      }

      &:after {
        content: '';
        display: inline;
        width: 100%;
        height: 10px;
        background: url('~@/assets/icon/graph-dot.svg') right center no-repeat;
        order: 2;
        margin-left: auto;
      }
    }
  }

  &_label {
    width: 60px;
    max-width: 60px;
    min-width: 60px;
    line-height: 1.2;
    white-space: nowrap;

    .-lg & {
      font-size: 1.8rem;
      width: 90px;
      max-width: 90px;
      min-width: 90px;
      flex-shrink: 0;
    }
  }

  &_rate {
    height: 14px;
    display: flex;

    @media screen and (min-width: 375px) and (max-width: 410px) {
      height: 11px;
    }

    span {
      display: block;
      width: 14px;
      height: 14px;
      margin-left: 3px;
      background-image: url('~@/assets/icon/star.svg');
      background-size: 14px 14px;

      @media screen and (min-width: 375px) and (max-width: 410px) {
        width: 11px;
        height: 11px;
        background-size: 11px 11px;
      }

      &.is-active {
        background-image: url('~@/assets/icon/star_on.svg');
      }
    }

    .-lg & {
      height: 24px;
      flex-shrink: 0;
      order: 3;
      margin-left: 8px;

      span {
        width: 24px;
        height: 24px;
        background-size: 24px 24px;
        margin-left: 5px;
      }
    }
  }
}
</style>
